import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Copy start end route configuration from the current territory to another territory
 */
export const copyDynamicLoadsCf = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/copyDynamicLoadsCf', async (territoryId: string, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/territory/copyDynamicLoadsCf', {
      type: 'rpc/territory/copyDynamicLoadsCf',
      category: 'rpc',
      territoryId,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {copyDynamicLoadsCf}`,
      { tags: ['rpc', 'territory'], info: { territoryId, error } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Copy of dynamic loads/cf configuration failed`,
      error,
    })
  }
})
